import { render, staticRenderFns } from "./listAgent.vue?vue&type=template&id=2bf96e24&scoped=true"
import script from "./listAgent.vue?vue&type=script&lang=js"
export * from "./listAgent.vue?vue&type=script&lang=js"
import style0 from "./listAgent.vue?vue&type=style&index=0&id=2bf96e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf96e24",
  null
  
)

export default component.exports